exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homework[data-v-20094380]{position:relative}.read-checkbox[data-v-20094380]{margin:0;top:0;position:absolute;right:10px}.read-checkbox input[data-v-20094380]{width:15px}.read-checkbox label[data-v-20094380]{cursor:pointer}.read[data-v-20094380]{opacity:.5}", ""]);

// exports
